module.exports = __webpack_public_path__ + "static/media/ico-lang-hover.da7e7873.svg";